export var KakaoOAuthTokenStatus;
(function (KakaoOAuthTokenStatus) {
    KakaoOAuthTokenStatus["LOGIN_NEEDED"] = "LOGIN_NEEDED";
    KakaoOAuthTokenStatus["ERROR"] = "ERROR";
    KakaoOAuthTokenStatus["SUCCEED"] = "SUCCEED";
})(KakaoOAuthTokenStatus || (KakaoOAuthTokenStatus = {}));
//# sourceMappingURL=definitions.js.map